import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';

const UnauthorizedPage: React.FC = () => {
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '80vh',
          textAlign: 'center',
        }}
      >
        <BlockIcon sx={{ fontSize: 100, color: 'error.main', mb: 2 }} />
        <Typography variant="h3" component="h1" gutterBottom>
          Access Denied
        </Typography>
        <Typography variant="h5" color="text.secondary" paragraph>
          You don't have permission to access this page.
        </Typography>
        <Box sx={{ mt: 4 }}>
          <Button variant="contained" component={RouterLink} to="/">
            Return to Home
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default UnauthorizedPage; 